var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-autocomplete',_vm._b({ref:"autocomplete",attrs:{"label":_vm.label,"items":_vm.items},on:{"change":_vm.changeItem,"click:append":function($event){return _vm.$emit('clickappend')}}},'v-autocomplete',_vm.$attrs,false))}
var staticRenderFns = []

export { render, staticRenderFns }